<h3>{{ label }}</h3>
<label class="toggle-switch">
  <input type="checkbox" [(ngModel)]="selected" (change)="isSelected($event)" />
  <div class="slider {{ selected ? 'checked' : '' }}"></div>
</label>
